var render = function render(){var _vm=this,_c=_vm._self._c;return _c('exception-page',{attrs:{"type":"403"}})
}
var staticRenderFns = []

export { render, staticRenderFns }